"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_UPDATE_DATE_FORMAT = void 0;
const BaseController_1 = __importDefault(require("./BaseController"));
const Formatters_1 = require("../common/Formatters");
const AuthService_1 = __importDefault(require("../services/AuthService"));
exports.API_UPDATE_DATE_FORMAT = "YYYY-MM-DD HH:mm";
const convertApiPersonTestsToWebPerson = (apiItems) => {
    return apiItems.map((p) => {
        const cp = {
            mitId: p.mit_id,
            name: p.display_name,
            kerberosId: p.kerberos,
            phoneNumber: p.phone_number,
            dateOfBirth: p.date_of_birth,
            jobTitle: p.job_title,
            department: p.department,
            studentYear: p.student_year,
            gender: p.gender ? p.gender.toLowerCase() : "",
            email: p.email,
            isCleared: p.cleared,
            initialTestScheduled: p.initial_test_scheduled,
            createdOn: (0, Formatters_1.toLocalTimeFromUct)(p.symptoms_reported_on),
            createdBy: p.created_by,
            notes: [],
            nextTestDate: p.test_date,
            waiverSignedOn: p.waiver_signed_on ? (0, Formatters_1.toLocalTimeFromUct)(p.waiver_signed_on) : undefined,
            testGuid: p.test_guid ? p.test_guid : undefined,
        };
        return cp;
    });
};
const getResult = (res) => {
    switch (res) {
        case 1:
            return "Positive";
        case -1:
            return "Negative";
        case 0:
            return "Invalid";
    }
    return "";
};
const convertApiPersonResultsToWebPerson = (apiItems) => {
    return apiItems.map((p) => {
        const cp = {
            mitId: p.mit_id,
            name: p.display_name,
            kerberosId: p.kerberos,
            phoneNumber: p.phone_number,
            dateOfBirth: p.date_of_birth,
            gender: p.gender ? p.gender.toLowerCase() : "",
            email: p.email,
            isCleared: p.cleared,
            initialTestScheduled: p.initial_test_scheduled,
            createdOn: (0, Formatters_1.toLocalTimeFromUct)(p.symptoms_reported_on),
            createdBy: p.created_by,
            notes: [],
            nextTestDate: p.test_date,
            waiverSignedOn: p.waiver_signed_on ? (0, Formatters_1.toLocalTimeFromUct)(p.waiver_signed_on) : undefined,
            testGuid: p.test_guid ? p.test_guid : undefined,
            result: getResult(p.result),
            resultDate: p.result_date ? (0, Formatters_1.toLocalTimeFromUct)(p.result_date) : undefined,
            sampleId: p.accession_number,
            exported: p.exported && p.exported == 1 ? "Yes" : "No",
            testDate: p.test_date,
        };
        return cp;
    });
};
class MedicalApi extends BaseController_1.default {
    constructor() {
        super();
        this.fetchAllHolds = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_all_holds, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchAllVaccineHolds = (from = 1, to = undefined) => __awaiter(this, void 0, void 0, function* () {
            let query = "";
            if (from !== undefined && to !== undefined && from > 0) {
                query = `?from=${from}&to=${to}`;
            }
            let response = yield fetch(this.url_all_vaccine_holds + query, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchAllVaccineExemptions = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_all_vaccine_exemptions, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchPersonTests = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_tests, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: convertApiPersonTestsToWebPerson(data) };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchTexts = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_texts, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.postSchedule = (kerbId, date, result) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_complete_tests, yield this.requestHeaderPost({
                kerberos: kerbId,
                date: date,
                result: result.toLowerCase(),
            }));
            if (this.checkStatusCode(response.status)) {
                // let data = await response.json()
                return {
                    success: true,
                };
            }
            else {
                try {
                    let text = yield response.json();
                    return Promise.reject(text.message);
                }
                catch (e) {
                    let text = yield response.text();
                    return Promise.reject(text);
                }
            }
        });
        this.postClear = (kerbId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_clear, yield this.requestHeaderPost({ kerberos: kerbId }));
            return yield this.genericResponse(response);
        });
        this.postOnHold = (mitId, reasonId, description) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_post_hold, yield this.requestHeaderPost({
                mit_id: mitId,
                reason_id: reasonId,
                comment: description,
            }));
            return yield this.genericResponse(response);
        });
        this.postExemptions = (mitId, exemptionFlags, description) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_post_hold, yield this.requestHeaderPost({
                mit_id: mitId,
                medical: exemptionFlags.medical,
                hr: exemptionFlags.hr,
                international: exemptionFlags.international,
            }));
            return yield this.genericResponse(response);
        });
        this.patchStatus = (statusGuid, newId, exemptFromTesting, clear_schedule_time, clear_schedule) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_patch_hold}${statusGuid}`, yield this.requestHeaderPatch({
                status_id: newId,
                exempt_retest_extended_period: exemptFromTesting,
                clear_schedule_time: clear_schedule_time || null,
                clear_schedule: clear_schedule || false,
            }));
            return yield this.genericResponse(response);
        });
        this.patchVaccineHoldStatus = (statusGuid, newId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_patch_vaccine_hold}${statusGuid}`, yield this.requestHeaderPatch({
                status_id: newId,
            }));
            return yield this.genericResponse(response);
        });
        this.downloadManifest = (from, to) => __awaiter(this, void 0, void 0, function* () {
            let queryParams = ``;
            if (from && to) {
                queryParams = `?from=${from.format("YYYY-MM-DD [00:00]")}&to=${to.format("YYYY-MM-DD [24:00]")}`;
            }
            let response = yield fetch(this.url_results_download + queryParams, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.text();
                return {
                    data: data,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.uploadFile = (file) => __awaiter(this, void 0, void 0, function* () {
            return yield this.uploadFileResults(file.name, file.file);
        });
        this.uploadFileResults = (name, data) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "binary/octet-stream",
                    Authorization: "Bearer " + token,
                    "Content-Filename": name,
                }),
                // @ts-ignore
                body: data,
            };
            let response = yield fetch(`${this.url_results_upload}?file_name=${name}`, options);
            if (this.checkStatusCode(response.status)) {
                return {
                    error: false,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.uploadVaccineResults = (name, data) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "binary/octet-stream",
                    Authorization: "Bearer " + token,
                    "Content-Filename": name,
                }),
                // @ts-ignore
                body: data,
            };
            let response = yield fetch(`${this.url_vaccine_upload}?file_name=${name}`, options);
            if (this.checkStatusCode(response.status)) {
                return {
                    error: false,
                };
            }
            else {
                let data = yield response.json();
                return {
                    error: true,
                    errorMessage: data,
                };
            }
        });
        this.uploadVaccineEligibleResults = (name, data) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const options = {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "binary/octet-stream",
                    Authorization: "Bearer " + token,
                    "Content-Filename": name,
                }),
                // @ts-ignore
                body: data,
            };
            let response = yield fetch(`${this.url_eligible_upload}?file_name=${name}`, options);
            if (this.checkStatusCode(response.status)) {
                return {
                    error: false,
                };
            }
            else {
                let data = yield response.json();
                return {
                    error: true,
                    errorMessage: data,
                };
            }
        });
        this.putPersonVaccineExemption = (mitId, exemptionFlags) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_person_exemptions + `/${mitId}`, yield this.requestHeaderPut(exemptionFlags));
            return yield this.genericResponse(response);
        });
        this.fetchPersonResults = (date) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_results + `?date=${date}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: convertApiPersonResultsToWebPerson(data) };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchFluShotResults = (date) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_flu_shot_detail + `?date=${date}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return {
                    error: false,
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchVaccineResults = (date, only_completed) => __awaiter(this, void 0, void 0, function* () {
            let query = "";
            if (date) {
                query = `?date=${date}`;
            }
            if (only_completed)
                query = `?only_completed=true`;
            let response = yield fetch(this.url_vaccine_detail + query, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return {
                    error: false,
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.putMedicalScheduleIrregular = (mitId, medical_schedule_irregular) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_schedule_irregular, yield this.requestHeaderPut({
                mit_id: mitId,
                medical_schedule_irregular: medical_schedule_irregular,
            }));
            return yield this.genericResponse(response);
        });
        this.fetchVaccineCourse = (id) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_detail}/course?mit_id=${id}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchVaccineStatus = (id) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_detail}/status?mit_id=${id}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.getVaccineProofFiltered = (filters) => __awaiter(this, void 0, void 0, function* () {
            let url = new URL(this.url_vaccine_proof_admin);
            if (filters) {
                Object.keys(filters).forEach((key) => {
                    if (filters[key] !== null && typeof filters[key] !== undefined) {
                        url.searchParams.append(key, filters[key]);
                    }
                });
            }
            let response = yield fetch(url.toString(), yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.getVaccineProof = (filters) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_vaccine_proof, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.putVaccineProof = (body) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_vaccine_proof_admin, yield this.requestHeaderPut(body));
            return yield this.genericResponse(response);
        });
        this.fetchVaccineTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_type}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchRejectionTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_rejection_type}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchVaccineCompanies = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_company}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
        //EXEMPTION
        this.fetchVaccineExemption = (id, includes) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_exemptions}${id ? `?mitId=${id}` : ""}${includes ? `${id ? `&` : `?`}includes=${includes}` : ""}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return {
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
        this.fetchVaccineExemptionPDF = (exemptionId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_exemptions_pdf}/${exemptionId}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.blob();
                return data;
            }
            else {
                const text = yield response.json();
                return yield Promise.reject(text === null || text === void 0 ? void 0 : text.message);
            }
        });
        this.fetchExemptionAuth = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_exemption_auth}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                const text = yield response.text();
                return yield Promise.reject(text);
            }
        });
        this.fetchExemptionTypes = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.apiHost}/${this.apiPathVaccineV2}/exemptions/types`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                const text = yield response.text();
                return yield Promise.reject(text);
            }
        });
        // putExemptionApproval = async (exemptionId: string, status: "A" | "R" | "M", feedback?: string): Promise<PostStatusResponse> => {
        // 	let response = await fetch(`${this.url_exemption_status}?id=${exemptionId}&status=${status}`, await this.requestHeaderPut({ feedback: feedback }));
        // 	if (response.status === 200) {
        // 		const data = await response.json();
        // 		return data;
        // 	}
        // 	const text = await response.text();
        // 	return await Promise.reject(text);
        // };
        this.putExemptionApproval = (body) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_exemption_status}`, yield this.requestHeaderPut(body));
            if (response.status === 200) {
                const data = yield response.json();
                return data;
            }
            const text = yield response.text();
            return yield Promise.reject(text);
        });
        this.postExemptionRequest = (body) => __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_exemption_request, postOptions);
            if (response.status >= 200 && response.status < 300) {
                const data = yield response.json();
                return data;
            }
            const text = yield response.text();
            return yield Promise.reject(text);
        });
        this.url_clear = `${this.apiHost}/${this.apiPathCovid}/clear`;
        this.url_fetch_results = `${this.apiHost}/${this.apiPathMedical}/tests/results`;
        this.url_pending_tests = `${this.apiHost}/${this.apiPathMedical}/tests/pending`;
        this.url_tests = `${this.apiHost}/${this.apiPathMedical}/tests`;
        this.url_flu_shot_detail = `${this.apiHost}/${this.apiPathMedical}/tests/flushot`;
        this.url_complete_tests = `${this.apiHost}/${this.apiPathMedical}/tests/manual_complete`;
        this.url_results = `${this.apiHost}/${this.apiPathMedical}/results`;
        this.url_results_download = `${this.apiHost}/${this.apiPathMedical}/results/download`;
        this.url_results_upload = `${this.apiHost}/${this.apiPathMedical}/results/upload`;
        this.url_eligible_upload = `${this.apiHost}/${this.apiPathMedical}/results/upload_vaccine_eligible`;
        this.url_vaccine_upload = `${this.apiHost}/${this.apiPathMedical}/results/upload_vaccine`;
        this.url_all_holds = `${this.apiHost}/${this.apiPathMedical}/medical/hold`;
        this.url_texts = `${this.apiHost}/${this.apiPathMedical}/medical/texts`;
        this.url_post_hold = `${this.apiHost}/${this.apiPathMedical}/medical/hold`;
        this.url_hold_reasons = `${this.apiHost}/${this.apiPathMedical}/medical/hold/reasons`;
        this.url_person_holds = `${this.apiHost}/${this.apiPathMedical}/medical/hold`;
        this.url_hold_statuses = `${this.apiHost}/${this.apiPathMedical}/medical/hold/statuses`;
        this.url_patch_hold = `${this.apiHost}/${this.apiPathMedical}/medical/hold/`;
        this.url_schedule_irregular = `${this.apiHost}/${this.apiPathMedical}/medical/schedule_irregular`;
        this.url_all_vaccine_holds = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold`;
        this.url_person_vaccine_holds = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold`;
        this.url_vaccine_hold_statuses = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold/statuses`;
        this.url_patch_vaccine_hold = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold/`;
        this.url_vaccine_detail = `${this.apiHost}/${this.apiPathVaccine}/vaccine`;
        this.url_vaccine_type = `${this.apiHost}/${this.apiPathVaccine}/vaccine/type`;
        this.url_rejection_type = `${this.apiHost}/${this.apiPathVaccineV2}/vaccinations/reasons`;
        this.url_vaccine_company = `${this.apiHost}/${this.apiPathVaccineV2}/company`;
        this.url_vaccine_proof = `${this.apiHost}/${this.apiPathVaccine}/vaccine/proof/upload`;
        this.url_vaccine_proof_admin = `${this.apiHost}/${this.apiPathVaccine}/vaccine/proof/admin`;
        this.url_person_vaccine_proof = `${this.apiHost}/${this.apiPathVaccine}/vaccine/proof/upload`;
        this.url_all_vaccine_exemptions = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold/exemptions`;
        this.url_person_exemptions = `${this.apiHost}/${this.apiPathVaccine}/vaccine/hold/exemptions/flags`;
        this.url_vaccine_exemptions = `${this.apiHost}/${this.apiPathVaccineV2}/exemptions`;
        this.url_vaccine_exemptions_pdf = `${this.apiHost}/${this.apiPathVaccine}/exemptions/proof`;
        this.url_exemption_status = `${this.apiHost}/${this.apiPathVaccineV2}/exemptions/status`;
        this.url_exemption_auth = `${this.apiHost}/${this.apiPathVaccineV2}/exemptions/auth`;
        this.url_exemption_documentation_upload = `${this.apiHost}/${this.apiPathVaccineV2}/documents/url`;
        this.url_exemption_request = `${this.apiHost}/${this.apiPathVaccineV2}/exemptions/on-behalf`;
        this.url_vaccine_documents = `${this.apiHost}/${this.apiPathVaccineV2}/documents`;
        this.url_get_person = `${this.apiHost}/${this.apiPathVaccine}/person`;
        this.url_vaccine_clear = `${this.apiHost}/${this.apiPathVaccineV2}/vaccinations/clear`;
    }
    fetchHoldReasons() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_hold_reasons, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchHoldStatuses() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_hold_statuses, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchVaccineHoldStatuses() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_vaccine_hold_statuses, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchTestResults(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_fetch_results}${mitId ? `?mit_id=${mitId}&optional=medical,flu_shots,vaccine` : ``}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return {
                    items: data
                        ? data.slice(0, 20).map((item) => ({
                            date: item.test_date,
                            accession_number: item.accession_number,
                            result: (0, Formatters_1.getResultText)(item.result, item),
                        }))
                        : undefined,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchPendingTests(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_pending_tests}${mitId ? `?mitId=${mitId}` : ``}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                return data;
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    cancelPendingTests(mitId, accessionNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const deleteOptions = {
                method: "DELETE",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify({ mitId, accessionNumber }),
            };
            let response = yield fetch(`${this.url_pending_tests}`, deleteOptions);
            console.log("cancelPendingTests", response);
            if (response.status === 200 || response.status === 204) {
                return true;
            }
            else {
                let err = yield response.json();
                return Promise.reject(err);
            }
        });
    }
    fetchPersonMedicalHolds(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_person_holds}?mit_id=${mitId}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                if (data.length > 0) {
                    data.forEach((d) => {
                        (d.created_on = d.created_on ? (0, Formatters_1.toLocalTimeFromUct)(d.created_on) : d.created_on), (d.updated_on = d.updated_on ? (0, Formatters_1.toLocalTimeFromUct)(d.updated_on) : d.updated_on);
                    });
                }
                return {
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchPersonVaccineExemption(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_person_exemptions}/${mitId}`, yield this.requestHeaderGet());
            if (response.status === 200) {
                let flags = yield response.json();
                if (flags) {
                    return { flags };
                }
                else {
                    return { error: true };
                }
            }
            else {
                return { error: true };
            }
        });
    }
    postVaccineCourse(body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const postOptions = {
                method: "POST",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_vaccine_detail + `/course`, postOptions);
            if (response.status === 200 || response.status === 201) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    deleteVaccineCourse(body) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const deleteOptions = {
                method: "DELETE",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(body),
            };
            let response = yield fetch(this.url_vaccine_detail + `/course`, deleteOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
    fetchPersonVaccineProofs(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_person_vaccine_proof}?mit_id=${mitId}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                /* if (data.length > 0) {
                    data.forEach((d: HoldModel) => {
                        (d.created_on = d.created_on ? toLocalTimeFromUct(d.created_on) : d.created_on), (d.updated_on = d.updated_on ? toLocalTimeFromUct(d.updated_on) : d.updated_on);
                    });
                } */
                return {
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchPersonVaccineDocuments(mitId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_vaccine_documents}${mitId ? `?mitId=${mitId}` : ""}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                /* if (data.length > 0) {
                    data.forEach((d: HoldModel) => {
                        (d.created_on = d.created_on ? toLocalTimeFromUct(d.created_on) : d.created_on), (d.updated_on = d.updated_on ? toLocalTimeFromUct(d.updated_on) : d.updated_on);
                    });
                } */
                return {
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    fetchPersonVaccineProofsFromGuid(proofGuid) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_person_vaccine_proof}/${proofGuid}`, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                let data = yield response.json();
                /* if (data.length > 0) {
                    data.forEach((d: HoldModel) => {
                        (d.created_on = d.created_on ? toLocalTimeFromUct(d.created_on) : d.created_on), (d.updated_on = d.updated_on ? toLocalTimeFromUct(d.updated_on) : d.updated_on);
                    });
                } */
                return {
                    items: data,
                };
            }
            else if (response.status === 507 || response.status === 403) {
                return {
                    unauth: true,
                };
            }
            else {
                return {
                    error: true,
                };
            }
        });
    }
    getExemptionDocumentUrl(image_key, fileName, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            let url;
            image_key
                ? (url = `${this.url_exemption_documentation_upload}?docKey=${image_key}&contentType=${fileType}&fileName=${fileName}`)
                : (url = `${this.url_exemption_documentation_upload}?contentType=${fileType}&fileName=${fileName}`);
            let response = yield fetch(url, yield this.requestHeaderGet());
            if (this.checkStatusCode(response.status)) {
                return { data: yield response.json() };
            }
            else {
                const text = yield response.text();
                return yield Promise.reject(text);
            }
        });
    }
    uploadExemptionProof(url, file, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": file.type,
                }),
                body: file,
            };
            let response = yield fetch(url, putOptions);
            // let response = await this.useFetch('PUT', 'put/upload', url, file, undefined, true)
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            else {
                let text = yield response.text();
                return Promise.reject(text);
            }
        });
    }
    fetchPerson(krbName) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_get_person + "/" + krbName, yield this.requestHeaderGet());
            if (response.status >= 200 && response.status < 300) {
                let data = yield response.json();
                return {
                    data: data,
                };
            }
            else {
                const text = yield response.text();
                return yield Promise.reject(text);
            }
        });
    }
    clearVaccine(id) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = yield AuthService_1.default.getToken();
            const deleteOptions = {
                method: "DELETE",
                headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                })
            };
            let response = yield fetch(`${this.url_vaccine_clear}/${id}`, deleteOptions);
            if (response.status === 200 || response.status === 204) {
                return true;
            }
            else {
                let err = yield response.json();
                return Promise.reject(err);
            }
        });
    }
}
const medicalApi = new MedicalApi();
exports.default = medicalApi;
